import ZonePerturbeComponent from './components/zone-perturbe/zone-perturbe.component';
import ContactComponent from './components/contact/contact.component';
import ConstatComponent from './components/constat/constat.component';
import FinAntennisteComponent from './components/fin-antenniste/fin-antenniste.component';
import typeProblemeFilter from '../common/filters/type-probleme.filter';

import routerConfig from './routes';

require('./antenniste.scss');

const moduleName = 'dmattnt-antenniste';
angular.module(moduleName, ['ui.router'])
  .component('dmattntZonePerturbe', new ZonePerturbeComponent())
  .component('dmattntContact', new ContactComponent())
  .component('dmattntConstat', new ConstatComponent())
  .component('dmattntFinAntenniste', new FinAntennisteComponent())
  .filter('labelTypeProbleme', typeProblemeFilter)

  .config(routerConfig);

export default {
  moduleName
};



// WEBPACK FOOTER //
// ./src/modules/antenniste/antenniste.module.js